module.exports = __webpack_public_path__ + "img/Demsan.f1683506.png";